import React, { useContext, useEffect, useRef } from "react";

import styles from "./styles/EditNotaryPopup.module.css";
import { UserData } from "../../../Context/DataContext";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";

import InfoTitle from "../Info/InfoTitle";
import Confirmation from "../../Confirmation/Confirmation";
import { GenerateID, RandomId } from "../../../Utils/RandomId";
import { floatMessage } from "../../../Utils/floatMessage";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import parse from "html-react-parser";
import useWindowDimensions from "../../Footer/footer";

function EditNotaryPopup({ toEdit, onClose, disabled = false }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const { width } = useWindowDimensions();
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddNotaryPopup.AddNotaryPopup);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const userData = UserData();

  const [modal, setModal] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  // There needs to be a trusted advisor and a notary with the same data. This means that if there is a
  // trustee having the same phone number, email and  name as the notary, we need to grab that one
  const associated_trustee = userData?.UserData?.trustees?.filter(
    (e) => e?.user_id === toEdit?.associated_trustee
  )[0];
  const [notary, setNotary] = useState({
    user_id: toEdit?.user_id,
    name: toEdit?.name,
    email: toEdit?.email,
    phone_number: toEdit?.phone_number,
    address: toEdit?.address,
    additional_information: toEdit?.additional_information,
    notify: toEdit?.notify,
    type: toEdit?.type,
    associated_trustee: toEdit?.associated_trustee,
  });

  const [error, setError] = useState({
    name: "",
    email: "",
    phone_number: "",
  });

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const handleChangeDescription = () => {
    const textArea = document.getElementById("textarea");
    textArea.style.height = "0";
    const height = textArea.scrollHeight;
    textArea.style.height = `${height}px`;
  };
  useEffect(() => {
    handleChangeDescription();
  }, []);
  const validateData = () => {
    var errors_ = {};
    var isError = false;
    if (!isValidEmail(notary.email)) {
      errors_["email"] = dublicatedcontent?.dublicatedText47;
      isError = true;
    }
    if (notary.email === "") {
      errors_["email"] = content?.addNotaryPopupError2;
      isError = true;
    }
    if (notary.name === "") {
      errors_["name"] = content?.addNotaryPopupError3;
      isError = true;
    }
    if (notary.phone_number.length < 5) {
      errors_["phone_number"] = content?.addNotaryPopupError4;
      isError = true;
    }
    if (notary.type === "") {
      errors_["type"] = "Please select an option";
      isError = true;
    }
    setError(errors_);
    setTimeout(() => {
      setError({
        name: "",
        email: "",
        phone_number: "",
      });
    }, 5000);
    return isError;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (validateData()) {
      return;
    }
    if (
      userData.UserData.legal?.length > 0 &&
      userData.CustomerUser?.show_legal_data
    ) {
      onClose();
      return;
    }
    let new_trustees =
      userData?.UserData?.trustees?.filter(
        (e) => e?.user_id !== associated_trustee?.user_id
      ) || [];
    if (associated_trustee) {
      new_trustees = [
        ...new_trustees,
        {
          ...associated_trustee,
          name: notary?.name,
          additional_information: notary?.additional_information,
          email: notary?.email,
          phone_number: notary?.phone_number,
          awareness_status: notary?.notify,
        },
      ];
    } else {
      const trustee_index = new_trustees.map((trustee) => {
        return trustee.user_id;
      });
      const customer_id = userData?.UserData?.user_id;
      const trustee = {
        user_id: GenerateID(customer_id, "T", trustee_index),
        name: notary?.name,
        additional_information: notary?.additional_information,
        email: notary?.email,
        phone_number: notary?.phone_number,
        awareness_status: false,
        assets: [],
        beneficiaries: [],
      };
      new_trustees = [...new_trustees, trustee];
      notary.associated_trustee = trustee?.user_id;
    }

    userData.setUserData({
      ...userData.UserData,
      trustees: new_trustees,
      legal: [notary],
    });
    floatMessage(dublicatedcontent?.saved);
    onClose();
  };

  const editNotary = (key, value) => {
    try {
      setNotary({ ...notary, [key]: value });
    } catch (e) {
      console.log(e);
    }
  };

  const trimNameField = (value) => {
    const name = value.trim();
    editNotary("name", name);
  };

  useEffect(() => {}, [notary]);
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  const deleteNotary = async () => {
    // ==================== delete notary logic
    userData.setUserData({
      ...userData.UserData,
      legal: [],
      trustees: userData?.UserData?.trustees.filter(
        (e) => e.user_id !== notary?.associated_trustee
      ),
    });
    userData.Update(RandomId(10));
    floatMessage(dublicatedcontent?.deleted);
  };

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        <div className={styles.title}>{content.addNotaryPopupTitle1}</div>
        <div
          className={styles.popup_scrollable}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />
          {/* <InfoTitle message={"Lorem ipsum text ..."} title={content.addNotaryPopupText1} /> */}
          <div
            className={styles.large_text}
            style={{
              maxWidth: "100%",
            }}
          >
            {parse(content.addNotaryPopupText2)}
          </div>

          <div className={styles.center}>
            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText3}
                </div>
                <select
                  disabled={
                    userData.isFreezed ||
                    (userData.UserData.legal?.length > 0 &&
                      userData.CustomerUser?.show_legal_data)
                  }
                  defaultValue={String(notary.type)}
                  onChange={(e) => editNotary("type", e.target.value)}
                  className={` legalInput ${styles.select} ${
                    error.type ? styles.field_error : ""
                  }`}
                >
                  <option value="Notary">{content.addNotaryPopupText5}</option>
                  <option value="Lawyer">{content.addNotaryPopupText6}</option>
                  <option value="Wealth Manager">
                    {content.addNotaryPopupText22}
                  </option>
                </select>
                <div className={styles.error_message}>
                  {error.priority ? error.priority : null}
                </div>
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText7}
                </div>
                <input
                  disabled={
                    userData.isFreezed ||
                    (userData?.UserData.legal?.length > 0 &&
                      userData.CustomerUser?.show_legal_data)
                  }
                  onBlur={(e) => trimNameField(e.target.value)}
                  onChange={(e) => editNotary("name", e.target.value)}
                  value={notary.name}
                  className={`legalInput ${styles.beneficiary_input} ${
                    error.name ? styles.field_error : ""
                  }`}
                  placeholder={content.addNotaryPopupText8}
                ></input>
                <div className={styles.error_message}>
                  {error.name ? error.name : null}
                </div>
              </div>

              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText9}
                </div>
                <div
                  className={`legalInput ${styles.phone_div} ${
                    error.phone_number ? styles.phone_div_error : ""
                  }`}
                >
                  <PhoneInput
                    inputClass="legalInput"
                    disabled={
                      userData.isFreezed ||
                      (userData.UserData.legal?.length > 0 &&
                        userData.CustomerUser?.show_legal_data)
                    }
                    countryCodeEditable={false}
                    localization={
                      websiteCurrentLang?.label === "fr"
                        ? fr_phone_countries
                        : undefined
                    }
                    country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                    placeholder={content.addNotaryPopupText10}
                    onChange={(e, countryData) => {
                      editNotary("phone_number", e);
                    }}
                    value={notary.phone_number}
                  />
                </div>
                <div className={styles.error_message}>
                  {error.phone_number ? error.phone_number : null}
                </div>
              </div>
            </div>

            <div className={styles.field_wrap}>
              <div className={styles.field}>
                <div
                  className={`${styles.input_title} ${styles.required_field}`}
                >
                  {content.addNotaryPopupText11}
                </div>
                <input
                  disabled={
                    userData.isFreezed ||
                    (userData.UserData.legal?.length > 0 &&
                      userData.CustomerUser?.show_legal_data)
                  }
                  value={notary.email}
                  onChange={(e) =>
                    editNotary("email", e.target.value.toLowerCase())
                  }
                  className={`legalInput ${styles.beneficiary_input} ${
                    error.email ? styles.field_error : ""
                  }`}
                  placeholder={dublicatedcontent?.dublicatedText74}
                ></input>
                <div className={styles.error_message}>
                  {error.email ? error.email : null}
                </div>
              </div>

              <div className={styles.field}>
                <div className={styles.input_title}>
                  {content.addNotaryPopupText13}
                </div>
                <input
                  disabled={
                    userData.isFreezed ||
                    (userData.UserData.legal?.length > 0 &&
                      userData.CustomerUser?.show_legal_data)
                  }
                  value={notary.address}
                  onChange={(e) => editNotary("address", e.target.value)}
                  className={`legalInput ${styles.beneficiary_input}`}
                  placeholder={content?.addNotaryPopupText15}
                ></input>
              </div>
            </div>

            <div className={styles.message_field}>
              <div className={styles.input_title}>
                {content.addNotaryPopupText16}
              </div>
              <textarea
                style={{
                  height: "max-content !important",
                }}
                disabled={
                  userData.isFreezed ||
                  (userData.UserData.legal?.length > 0 &&
                    userData.CustomerUser?.show_legal_data)
                }
                maxLength={maxMessageLength}
                id="textarea"
                value={notary?.additional_information}
                placeholder={content.addNotaryPopupText16}
                onChange={(e) => {
                  editNotary("additional_information", e.target.value);
                  handleChangeDescription(e);
                }}
                className={`legalInput ${styles.large_message}`}
              ></textarea>
              <div
                className={`${styles.file_counter} ${
                  notary.additional_information?.length === maxMessageLength
                    ? styles.error_text
                    : ""
                }`}
              >
                {notary.additional_information?.length === maxMessageLength ? (
                  <>{content.addNotaryPopupText17}</>
                ) : (
                  ""
                )}
                {notary.additional_information?.length}/{maxMessageLength}{" "}
                {content.addNotaryPopupText21}
              </div>
            </div>
          </div>
          <div style={{ position: "relative", zIndex: "7" }}>
            {showConfirmation ? (
              <Confirmation
                cancel_button={dublicatedcontent?.dublicatedText184}
                confirm_button={dublicatedcontent?.delete}
                OnConfirm={() => {
                  deleteNotary();
                  window.scrollTo(0, 0);
                  onClose();
                }}
                title={dublicatedcontent?.dublicatedText211}
                text={`${dublicatedcontent?.are_you_sure_you_want_to_delete} ${
                  dublicatedcontent[
                    notary.type?.toLowerCase()?.replace(" ", "")
                  ]
                }?`}
                onClose={() => setShowConfirmation(false)}
              />
            ) : null}
          </div>
          {modal ? (
            <div style={{ position: "relative", zIndex: "7" }}>{modal}</div>
          ) : null}

          <div
            className={`${styles.shadow_bottom} ${
              showBottomShadow ? styles.active : ""
            }`}
          />
        </div>

        <div className={styles.actions_toolbar}>
          <button
            disabled={
              (userData.UserData.legal?.length > 0 &&
                userData.CustomerUser?.show_legal_data) ||
              disabled
            }
            onClick={() => setShowConfirmation(true)}
            className={styles.delete_button}
          >
            {content.addNotaryPopupText20}
          </button>
          <button
            disabled={disabled}
            onClick={() => onClose()}
            className={styles.cancel_button}
          >
            {content.addNotaryPopupText18}
          </button>
          <button
            disabled={
              (userData.UserData.legal?.length > 0 &&
                userData.CustomerUser?.show_legal_data) ||
              disabled
            }
            onClick={(e) => handleSave(e)}
            className={styles.save_button}
          >
            {content.addNotaryPopupText19}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditNotaryPopup;
